import { render, staticRenderFns } from "./ScheduleOverlap.vue?vue&type=template&id=545e5675&scoped=true"
import script from "./ScheduleOverlap.vue?vue&type=script&lang=js"
export * from "./ScheduleOverlap.vue?vue&type=script&lang=js"
import style0 from "./ScheduleOverlap.vue?vue&type=style&index=0&id=545e5675&prod&scoped=true&lang=css"
import style1 from "./ScheduleOverlap.vue?vue&type=style&index=1&id=545e5675&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e5675",
  null
  
)

export default component.exports